import React from 'react';
import { useUserExistsCheck } from 'src/payments/signup/views/email-form/use-user-exists-check';
import { EnrollmentSteps } from 'src/payments/constants';
import { ViewTextProps } from 'src/payments/dutchie-pay/signup';
import { useTrackEnrollmentStepViewed } from 'src/payments/hooks/use-dutchie-pay-analytics/use-track-enrollment-step-viewed';
import { EmailForm } from './email-form';

export function EmailFormWrapper({ titleText, subtitleText }: ViewTextProps): JSX.Element {
  const { userExistsCheckQuery } = useUserExistsCheck();

  const emailFormRef = useTrackEnrollmentStepViewed({ step: EnrollmentSteps.emailForm });

  return (
    <div ref={emailFormRef}>
      <EmailForm titleText={titleText} subtitleText={subtitleText} onSubmit={userExistsCheckQuery} />
    </div>
  );
}
